// TODO: Revise, if all stuff defined here is actually still used in the app.

export const BODY_AREA_CATEGORIES = [
  'Head and Neck',
  'Shoulders and Upper Back',
  'Chest',
  'Back',
  'Arms',
  'Core',
  'Lower Body',
  'Full Body',
] as const;

export type BodyAreaCategoryT = typeof BODY_AREA_CATEGORIES[number];

export const BODY_AREAS = [
  'Arms',
  'Back',
  'Chest',
  'Core',
  'Deltoid - (Anterior, Lateral, Posterior)',
  'Full Body',
  'Head and Neck',
  'Lower Body',
  'Rhomboids',
  'Rotator Cuff Muscles',
  'Trapezius',
] as const;

export type BodyAreaT = typeof BODY_AREAS[number];

export const BODY_AREA_TREE: Record<BodyAreaCategoryT, BodyAreaT[]> = {
  Arms: ['Arms'],
  Back: ['Back'],
  Chest: ['Chest'],
  Core: ['Core'],
  'Full Body': ['Full Body'],
  'Head and Neck': ['Head and Neck'],
  'Lower Body': ['Lower Body'],
  'Shoulders and Upper Back': [
    'Deltoid - (Anterior, Lateral, Posterior)',
    'Trapezius',
    'Rhomboids',
    'Rotator Cuff Muscles',
  ],
};

/** The mapping from body areas to their categories. */
export const BODY_AREA_CATEGORY = {} as Record<BodyAreaT, BodyAreaCategoryT>;

for (const [category, areas] of Object.entries(BODY_AREA_TREE)) {
  for (const area of areas) {
    BODY_AREA_CATEGORY[area] = category as BodyAreaCategoryT;
  }
}

/**
 * Given an array of body areas it aggregates the array of body area categories
 * that include those body areas.
 */
export function toCategories(areas: BodyAreaT[]): BodyAreaCategoryT[] {
  const set = new Set<BodyAreaCategoryT>();
  for (const area of areas) set.add(BODY_AREA_CATEGORY[area]);
  const res = [...set];
  res.sort();
  return res;
}
